import contractsRepo from '@/repositories/contractsRepository';

const state = {
  searchContracts: [],
  recentlyOpenedContracts: [],
  isLoading: false,
  searchValue: '',
  searchFields: [
    'enterprise.name',
    'customer.firstName',
    'customer.lastName',
    'contractNumber',
    'simulationNumber',
  ],
};

const getters = {
  getContracts(st) {
    return st.searchValue.trim() !== ''
      ? st.searchContracts : st.recentlyOpenedContracts;
  },
  getSearchContracts(st) {
    return st.searchContracts;
  },
  getSearchValue(st) {
    return st.searchValue;
  },
  getIsLoading(st) {
    return st.isLoading;
  },
};

const mutations = {
  setSearchContracts(st, value) {
    st.searchContracts = value;
  },
  setRecentlyOpenedContracts(st, value) {
    st.recentlyOpenedContracts = value;
  },
  setSearchValue(st, value) {
    st.searchValue = value;
    st.searchContracts = [];
  },
  setIsLoading(st, value) {
    st.isLoading = value;
  },
};
const actions = {
  // eslint-disable-next-line no-shadow
  async searchContracts({ commit, state, dispatch }, searchValue) {
    commit('setIsLoading', true);
    commit('setSearchValue', searchValue);
    if (searchValue.trim() !== '') {
      commit('setSearchContracts', []);
      const response = await contractsRepo.searchContracts(state.searchFields, searchValue);
      if (response && response.status === 200 && !response.data.errors) {
        commit('setSearchContracts', response.data.data.searchContracts);
      } else {
        dispatch('general/setError', true, { root: true });
      }
    } else {
      commit('setSearchContracts', []);
    }
    commit('setIsLoading', false);
  },
  async getRecentlyOpenedContracts({ commit, dispatch }) {
    commit('setIsLoading', true);
    const response = await contractsRepo.getRecentlyOpenedContracts();
    if (response && response.status === 200 && !response.data.errors) {
      commit('setRecentlyOpenedContracts', response.data.data.recentlyOpenedContracts);
    } else {
      dispatch('general/setError', true, { root: true });
    }
    commit('setIsLoading', false);
  },
};


export default {
  state,
  mutations,
  getters,
  actions,
};
